import { render } from "./ImagePickerGallery.vue?vue&type=template&id=82894bb2&scoped=true"
import script from "./ImagePickerGallery.vue?vue&type=script&lang=js"
export * from "./ImagePickerGallery.vue?vue&type=script&lang=js"

import "./ImagePickerGallery.vue?vue&type=style&index=0&id=82894bb2&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82894bb2"]])

export default __exports__